import app from 'flarum/forum/app';
import PostPreview from 'flarum/forum/components/PostPreview';
import Modal from 'flarum/common/components/Modal';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import MentionedByModalState from '../state/MentionedByModalState';
import Form from 'flarum/common/components/Form';
export default class MentionedByModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.state = new MentionedByModalState({
      filter: {
        mentionedPost: this.attrs.post.id()
      },
      sort: 'number'
    });
    this.state.refresh();
  }
  className() {
    return 'MentionedByModal';
  }
  title() {
    return app.translator.trans('flarum-mentions.forum.mentioned_by.title');
  }
  content() {
    return m('[', null, m("div", {
      className: "Modal-body"
    }, this.state.isInitialLoading() ? m(LoadingIndicator, null) : m('[', null, m("ul", {
      className: "MentionedByModal-list Dropdown-menu Dropdown-menu--inline Post-mentionedBy-preview"
    }, this.state.getPages().map(page => page.items.map(reply => m("li", {
      "data-number": reply.number()
    }, m(PostPreview, {
      post: reply,
      onclick: () => app.modal.close()
    }))))))), this.state.hasNext() && m("div", {
      className: "Modal-footer"
    }, m(Form, {
      className: "Form--centered"
    }, m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--block",
      onclick: () => this.state.loadNext(),
      loading: this.state.isLoadingNext()
    }, app.translator.trans('flarum-mentions.forum.mentioned_by.load_more_button'))))));
  }
}
flarum.reg.add('flarum-mentions', 'forum/components/MentionedByModal', MentionedByModal);